/**
 * Intestazione riutilizzabile per le pagine Nora con titolo, sottotitolo e azioni.
 * @param {Object} props - Proprietà del componente
 * @param {string} props.title - Titolo principale della pagina
 * @param {string|import('react').ReactNode} [props.subtitle] - Sottotitolo opzionale sotto il titolo
 * @param {import('react').ReactNode} [props.actions] - Contenuto della colonna azioni (es. pulsanti)
 * @param {string} [props.className] - Classi CSS aggiuntive per il contenitore
 * @returns {import('react').JSX.Element} Header della pagina
 */
export const PageHeader = ({ title, subtitle, actions, className }) => (
  <div className={`nora-page__head ${className || ''}`.trim()}>
    <div>
      <h1 className="nora-page__title">{title}</h1>
      {subtitle != null &&
        subtitle !== '' &&
        (typeof subtitle === 'string' ? (
          <p className="nora-page__sub">{subtitle}</p>
        ) : (
          <div className="nora-page__sub">{subtitle}</div>
        ))}
    </div>
    {actions && <div className="nora-page__actions">{actions}</div>}
  </div>
)
